import { createCRUDHook } from './createCRUDHook';
import { StaffNotificationStationDto } from 'utils/models';
import {
  DELETE_ALL_STATION_BY_STAFF_ID,
  TBL_STAFF_NOTIFICATION_STATION,
} from './apiEndPoints';
interface StaffNotificationStationCustomOperations {
  deleteStaffNotificationStationByStaffId: (
    staffId: number
  ) => Promise<boolean>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  StaffNotificationStationDto,
  StaffNotificationStationDto[],
  StaffNotificationStationCustomOperations
>({
  entityName: 'StaffNotificationStation',
  endpoint: TBL_STAFF_NOTIFICATION_STATION,

  customOperations: (auth) => ({
    deleteStaffNotificationStationByStaffId: async (
      staffId: number
    ): Promise<boolean> => {
      try {
        const res = await auth.makeAuthenticatedDelete(
          TBL_STAFF_NOTIFICATION_STATION +
            DELETE_ALL_STATION_BY_STAFF_ID +
            `?staffId=${staffId}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return false;
      }
    },
  }),
});

export const StaffNotificationStationContext = Context;
export const useStaffNotificationStationManager = useManager;
export const useStaffNotificationStation = useConsumer;
